import type { LayoutHandleProps } from 'layouts/Layout/LayoutHandleProps';
import type { CmsApiPagePage } from 'modules/cms/api/types/CmsApiPage';
import { getCmsApiPageDefaultSearchType } from 'modules/cms/helpers/getCmsApiPageDefaultSearchType';
import { getContentLocaleUrl } from 'modules/cms/helpers/getContentLocaleUrl';
import { getHideFooterDivider } from 'modules/cms/helpers/getHideFooterDivider';
import { getIsNoAdPage } from 'modules/cms/helpers/getIsNoAdPage';

type Args = {
  loggedIn: boolean;
  content: CmsApiPagePage;
};

export function getCmsPagePageLayoutHandleProps({
  loggedIn,
  content,
}: Args): LayoutHandleProps {
  const defaultSearchType = getCmsApiPageDefaultSearchType({ content });

  // banner ads should not be on some pages
  const noAds = getIsNoAdPage(content, loggedIn);

  const hero = content.heroSearch?.onlyResults ? undefined : content.heroSearch;

  const hideFooterDivider = getHideFooterDivider({ content });
  const localeUrl = getContentLocaleUrl({ content });

  return {
    noAds,
    defaultSearchType,
    hideFooterDivider,
    urlByLocale: localeUrl,
    showDesktopSearch: !hero,
  };
}
